export const buttonProps = {
    text: "Submit",
    className:
        "bg-white border-solid border cursor-pointer block text-2xl leading-4 my-0 mx-auto py-18 px-20 text-center w-[360px] h-[61px] max-w-[90%] border-darkBlue  transition-all rounded-[30px] my-30 hover:border-white hover:border-solid hover:border hover:border hover:text-white hover:bg-primary",
    id: "btnNext",
}
